<script>
/**
 * Navbar component
 */
export default {
  data() {
    return {
      isCondensed: false,
    };
  },
  props: {
    isWhiteNavbar: {
      type: Boolean,
    },
    navLight: {
      type: Boolean,
    },
    isIcons: {
      type: Boolean,
    },
  },

  mounted: () => {
    window.onscroll = function () {
      onwindowScroll();
    };

    function onwindowScroll() {
      if (
        document.body.scrollTop > 50 ||
        document.documentElement.scrollTop > 50
      ) {
        document.getElementById("topnav").classList.add("nav-sticky");
      } else {
        document.getElementById("topnav").classList.remove("nav-sticky");
      }

      if (
        document.body.scrollTop > 100 ||
        document.documentElement.scrollTop > 100
      ) {
        document.getElementById("back-to-top").style.display = "inline";
      } else {
        document.getElementById("back-to-top").style.display = "none";
      }
    }

    var links = document.getElementsByClassName("side-nav-link-ref");
    var matchingMenuItem = null;
    for (var i = 0; i < links.length; i++) {
      if (window.location.pathname === links[i].pathname) {
        matchingMenuItem = links[i];
        break;
      }
    }

    if (matchingMenuItem) {
      matchingMenuItem.classList.add("active");
      var parent = matchingMenuItem.parentElement;

      /**
       * TODO: This is hard coded way of expading/activating parent menu dropdown and working till level 3.
       * We should come up with non hard coded approach
       */
      if (parent) {
        parent.classList.add("active");
        const parent2 = parent.parentElement;
        if (parent2) {
          parent2.classList.add("active");
          const parent3 = parent2.parentElement;
          if (parent3) {
            parent3.classList.add("active");
            const parent4 = parent3.parentElement;
            if (parent4) {
              const parent5 = parent4.parentElement;
              parent5.classList.add("active");
            }
          }
        }
      }
    }
  },
  methods: {
    /**
     * Toggle menu
     */
    toggleMenu() {
      this.isCondensed = !this.isCondensed;
      if (this.isCondensed) {
        document.getElementById("navigation").style.display = "block";
      } else document.getElementById("navigation").style.display = "none";
    },

    /**
     * Menu clicked show the submenu
     */
    onMenuClick(event) {
      event.preventDefault();
      const nextEl = event.target.nextSibling.nextSibling;

      if (nextEl && !nextEl.classList.contains("open")) {
        const parentEl = event.target.parentNode;
        if (parentEl) {
          parentEl.classList.remove("open");
        }
        nextEl.classList.add("open");
      } else if (nextEl) {
        nextEl.classList.remove("open");
      }
      return false;
    },
  },
};
</script>

<template>
  <div>
    <!-- Navbar STart -->
    <header
      id="topnav"
      class="defaultscroll sticky"
      :class="{ 'bg-white': isWhiteNavbar === true, 'nav-dark-bg': navLight === true }"
    >
      <div class="container">
        <!-- Logo container-->
        <div>
          <router-link class="logo" to="/" v-if="navLight !== true">
            <img src="/images/logo-dark.png" height="52" alt="" />
          </router-link>
          <router-link class="logo" to="/" v-else>
            <img src="/images/logo-dark.png" class="l-dark" height="52" alt="" />
            <img
              src="/images/logo-light.png"
              class="l-light"
              height="52"
              alt=""
            />
          </router-link>
        </div>
        <div class="buy-button d-none d-lg-block" v-if="isIcons !== true">
            <div class="text-right d-flex flex-column justify-content-center pt-4" style="line-height: 1.2;">
              <a href="tel:787-294-9663" class="nav-contact-link d-block" style="font-size: 14px; font-weight: 500; margin-bottom: 4px;">
                <i class="uil uil-phone"></i> 787-294-9663
              </a>
              <a href="mailto:dsi@dsincpr.com" class="nav-contact-link d-block" style="font-size: 13px;">
                <i class="uil uil-envelope"></i> dsi@dsincpr.com
              </a>
            </div>
        </div>
        <ul class="buy-button list-inline mb-0" v-if="isIcons === true">
          <li class="list-inline-item mb-0 developer-icon">
            <b-dropdown
              right
              variant="link"
              toggle-class="text-decoration-none p-0 pr-2"
              menu-class="dd-menu dropdown-menu-right bg-white shadow rounded border-0 mt-3 py-0"
            >
              <template #button-content>
                <i class="mdi mdi-magnify h4 text-muted"></i>
              </template>
              <div style="width: 300px">
                <form>
                  <input
                    type="text"
                    id="text"
                    name="name"
                    class="form-control border bg-white"
                    placeholder="Search..."
                  />
                </form>
              </div>
            </b-dropdown>
          </li>
          <li class="list-inline-item mb-0 pr-2">
            <a href="#" class="btn btn-icon btn-soft-primary"
              ><i class="mdi mdi-github mdi-18px icons"></i
            ></a>
          </li>
          <li class="list-inline-item mb-0 pr-2">
            <a href="#" class="btn btn-icon btn-soft-primary"
              ><i class="mdi mdi-stack-overflow mdi-18px icons"></i
            ></a>
          </li>
          <li class="list-inline-item mb-0">
            <a
              href="javascript:void(0)"
              class="btn btn-icon btn-soft-primary"
              data-toggle="modal"
              data-target="#productview"
              ><i class="mdi mdi-account-outline mdi-18px icons"></i
            ></a>
          </li>
        </ul>
        <!--end login button-->
        <!--end login button-->
        <!-- End Logo container-->
        <div class="menu-extras">
          <div class="menu-item">
            <!-- Mobile menu toggle-->
            <a
              class="navbar-toggle"
              @click="toggleMenu()"
              :class="{ open: isCondensed === true }"
            >
              <div class="lines">
                <span></span>
                <span></span>
                <span></span>
              </div>
            </a>
            <!-- End mobile menu toggle-->
          </div>
        </div>

        <div id="navigation">
          <!-- Navigation Menu-->
          <ul
            class="navigation-menu"
            :class="{ 'nav-light': navLight === true }"
          >
            <li>
              <router-link to="/" class="side-nav-link-ref">About Us</router-link>
            </li>
            <li class="has-submenu">
              <a href="javascript:void(0)" @click="onMenuClick">Product & Services</a
              ><span class="menu-arrow"></span>
              <ul class="submenu">
                <li>
                  <router-link to="/products/sharp" class="side-nav-link-ref">
                    Sharp
                  </router-link>
                </li>
                <li>
                  <router-link to="/products/konica-minolta" class="side-nav-link-ref">
                    Konica Minolta
                  </router-link>
                </li>
                <li>
                  <router-link to="/products/lexmark" class="side-nav-link-ref">
                    Lexmark
                  </router-link>
                </li>
                <li>
                  <router-link to="/products/hp" class="side-nav-link-ref">
                    HP
                    <span class="badge badge-pill badge-warning ml-2">Soon</span>
                  </router-link>
                </li>
                <li>
                  <router-link to="/products/brother" class="side-nav-link-ref">
                    Brother
                    <span class="badge badge-pill badge-warning ml-2">Soon</span>
                  </router-link>
                </li>
              </ul>
            </li>
            <li>
              <router-link to="/contact-us" class="side-nav-link-ref">Contact Us</router-link>
            </li>
          </ul>
          <!--end navigation menu-->

          <!--end contact info-->
        </div>
        <!--end navigation-->
      </div>
      <!--end container-->
    </header>
    <!--end header-->
    <!-- Navbar End -->
  </div>
</template>

<style>
.nav-contact-link {
  color: #3c4858 !important; /* Color oscuro por defecto */
}

/* Blanco cuando el navbar está sobre fondo oscuro */
.nav-dark-bg .nav-contact-link {
  color: white !important;
}

/* Oscuro cuando el navbar es sticky (fondo blanco) */
.nav-dark-bg.nav-sticky .nav-contact-link {
  color: #3c4858 !important;
}
</style>
